import { Fragment, type ReactNode } from 'react'

import Icon from '@/legacy-src/components/icons/Icon'
import { Button } from '@/legacy-src/components/ui/button'
import { Popover, PopoverContent, PopoverTrigger } from '@/legacy-src/components/ui/popover'

export interface ClientBookingPlannedEventPopoverProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  items: {
    text: ReactNode
    icon: string
    onClick: () => void
  }[]
  children?: ReactNode
}

export const ClientBookingPlannedEventPopover = ({
  open,
  onOpenChange,
  items,
  children,
}: ClientBookingPlannedEventPopoverProps) => (
  <Popover open={open} onOpenChange={onOpenChange}>
    <PopoverTrigger asChild>{children}</PopoverTrigger>
    <PopoverContent className="flex max-w-max flex-col rounded-xl bg-white p-0 text-sm font-bold text-secondary shadow-hedepy">
      {items.map((item, index) => (
        <Fragment key={index}>
          <Button onClick={item.onClick} variant="inline" className="justify-start text-nowrap text-secondary">
            <div className="m-5">
              <Icon size="sm" className="mr-2" icon={item.icon} />
              {item.text}
            </div>
          </Button>
          {index === items.length - 1 ? null : <hr className="border-1 m-0 w-full border-sand-500" />}
        </Fragment>
      ))}
    </PopoverContent>
  </Popover>
)
